export const FETCH_DATA_SUCCESS = "FETCH_DATA_SUCCESS";

export const FETCH_PRODUCT_SUCCESS = "FETCH_PRODUCT_SUCCESS";

export const GET_PRODUCT_DETAILS = "GET_PRODUCT_DETAILS";

export const REGISTER_SUCCESS = "REGISTER_SUCCESS";

export const REGISTER_FAILED = "REGISTER_FAILED";

export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";

export const FORTGOT_OTP_SUCCESS = "FORTGOT_OTP_SUCCESS";

export const FORTGOT_OTP_FAILED = " FORGOT_PASSWORD_FAILED";

export const GET_CATEGORY = "GET_CATEGORY";

export const ADD_TO_CART = "ADD_TO_CART";

export const GET_CART = "GET_CART";

export const DELETE_FROM_CART = "DELETE_FROM_CART";

export const CHECK_WISHLIST_PRODUCT = "CHECK_WISHILIST_PRODUCT";

export const UPDATE_CART = "UPDATE_CART";

export const SEARCH_RESULT_LIST = "SEARCH_RESULT_LIST   ";

export const ADD_TO_WISHLIST = "ADD_TO_WISHLIST";

export const GET_WISHLIST = "GET_WISHLIST";

export const REMOVE_FROM_WISHLIST = "REMOVE_FROM_WISHLIST";

export const MOVE_TO_CART = "MOVE_TO_CART";

export const GET_PROFILE = "GET_PROFILE";

export const GET_RECENT_PRODUCT = "RECENT_PRODUCT";

export const ADD_NEW_ADDRESS = "ADD_NEW_ADdRESS";

export const DELETE_ADDRESS = `DELETE_ADDRESS`;

export const UPDATE_ADDRESS = "UPDATE_ADDRESS";

export const FILTER_PRODUCTS = "FILTER_PRODUCTS";

export const ADD_TO_SUMMARY = `ADD_TO_SUMMARY`;

export const GET_ORDER_SUMMARY = "GET_ORDER_SUMMARY";

export const UPDATE_SUMMARY_QUANTITY = "UPDATE_SUMMARY_QUANTITY";

export const CART_TO_SUMMARY = "CART_TO_SUMMARY";

export const REMOVE_FROM_SUMMARY = "REMOVE_FROM_SUMMARY";

export const CREATE_ORDER = "CREATE_ORDER";

export const VERIFY_PAYMENT = "VERIFY_PAYMENT";

export const VERIFY_MOBILE_REGISTER = "VERIFY_MOBILE_REGISTER";
export const VERIFY_EMAIL_REGISTER = "VERIFY_EMAIL_REGISTER";

export const CHECK_DELIVERY = "CHECK_DELIVERY";

export const VERIFIED_FORGOT_PASSWORD = "VERIFIED_FORGOT_PASSWORD";

export const GET_MY_ORDER = "GET_MY_ORDER";

export const GET_MY_ORDER_SINGLE_DETAIL = 'GET_MY_ORDER_SINGLE_DETAIL';

export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';

export const BEST_PRODUCTS = 'BEST_PRODUCTS'

export const ADD_COMPARE_PRODUCTS = 'ADD_COMPARE_PRODUCTS';

export const CLEAR_ERROR        = 'CLEAR_ERROR'

export const REMOVE_COMPARE_PRODUCTS = 'REMOVE_COMPARE_PRODUCTS';

export const DIRECT_BUY_ADD_TO_PRODUCTS = 'DIRECT_BUY_ADD_TO_PRODUCTS';

export const GET_DIRECTBUY = 'GET_DIRECTBUY';

export const  INCREASE_QUANTITY_DIRECTBUY = 'ADD_QUANTITY_DIRECTBUY';

export const DECREASE_QUANTITY_DIRECTBUY = 'DECREASE_QUANTITY_DIRECTBUY';

export const REMOVE_QUANTITY_DIRECTBUY = 'REMOVE_QUANTITY_DIRECTBUY';

export const ADD_NEW_ADDRESS_DIRECTBUY = 'ADD_NEW_ADDRESS_DIRECTBUY'

export const GET_STATES = 'GET_STATES';

export const ADD_STATES_DATA = 'ADD_STATES_DATA';

export const GET_DISTRICTS = 'GET_DISTRICTS';
 
export const FILTER_UPDATE_STATE = 'FILTER_UPDATE_STATE';

export const GET_TRACKING_DATA = 'GET_TRACKING_DATA';